import axiosInstance from './api';

// Tenant API service
const tenantService = {
  // List all tenants (developer only)
  async listTenants() {
    const response = await axiosInstance.get('/developer/tenants');
    return response.data;
  },

  // Get tenant by ID
  async getTenant(tenantId) {
    const response = await axiosInstance.get(`/developer/tenants/${tenantId}`);
    return response.data;
  },

  // Create new tenant (developer only)
  async createTenant(data) {
    const response = await axiosInstance.post('/developer/tenants', data);
    return response.data;
  },

  // Update tenant
  async updateTenant(tenantId, updates) {
    const response = await axiosInstance.put(`/developer/tenants/${tenantId}`, updates);
    return response.data;
  },

  // Delete tenant (only if no organizations use it)
  async deleteTenant(tenantId) {
    const response = await axiosInstance.delete(`/developer/tenants/${tenantId}`);
    return response.data;
  },

  // Get tenant for current user's organization (any authenticated user)
  async getCurrentTenant() {
    const response = await axiosInstance.get('/tenant/current');
    return response.data;
  }
};

export default tenantService;
